export default class BillingFormController {
	constructor() {
		this.form = document.getElementById('billingForm');
		this.submitButton = document.getElementById('billingSubmit');

		this.STANDARD_PAYMENT_METHODS = [
			'PAYPAL',
			'ACCOUNT',
			'GOOGLEPAY',
			'IDEAL',
			'BANCONTACT',
			'EPS',
		];

		if (!this.form) return;

		this.form.addEventListener('submit', this.onSubmit.bind(this));
	}

	/**
	 * The main asynchronous submit handler.
	 * Coordinates all async checks based on payment type requirements.
	 */
	async onSubmit(event) {
		// 1. Check if FormControl (or any other script) has stopped submission.
		if (event.defaultPrevented) {
			return;
		}

		// 2. Take control and disable the button.
		event.preventDefault();
		this.disableButton();

		try {
			// 3. Run the Experian check (Required for all submissions).
			const didInvoiceEmailPass = await this.runExperianCheck();
			if (!didInvoiceEmailPass) {
				this.enableButton();
				return; // Stop, user cancelled
			}

			// If the user is an ASM agent or the payment UI is not available, submit immediately.
			const isAsmAgentLoggedIn =
				window.od?.journeyData?.navigation?.isAsmAgentLoggedIn;
			const isPaymentSelectionScreen = document.querySelector(
				'#billingForm > div.checkout-payment-methods',
			);

			if (isAsmAgentLoggedIn || !isPaymentSelectionScreen) {
				this.form.submit();
				return;
			}

			// 4. Decide submission path based on payment method.
			const paymentMethod = this.getPaymentMethod();

			if (paymentMethod === 'CARD') {
				// 5a. CARD PAYMENT: Requires client-side tokenization/3DS.
				// Call the Braintree worker script.
				const didBraintreePass = await this.runBraintreeCardPayment();
				if (!didBraintreePass) {
					this.enableButton(); // Braintree validation failed
				}
			} else if (this.STANDARD_PAYMENT_METHODS.includes(paymentMethod)) {
				// 5b. OTHER PAYMENTS (PayPal, GooglePay, Account, IDEAL, etc.):
				// All checks passed, so submit to advance to the Review Page.
				this.form.submit();
			} else {
				// 5c. FALLBACK: Unknown or Missing Payment Method
				this.enableButton();
			}
		} catch (error) {
			this.enableButton();
		}
	}

	/**
	 * Checks for the Experian validation function and runs it.
	 */
	async runExperianCheck() {
		if (typeof window.performExperianEmailCheck === 'function') {
			return window.performExperianEmailCheck();
		}
		return true; // No check function found, so we proceed
	}

	/**
	 * Checks for the Braintree CARD payment function and runs it.
	 */
	async runBraintreeCardPayment() {
		if (typeof window.performBraintreeCardPayment === 'function') {
			return window.performBraintreeCardPayment();
		}
		return false;
	}

	// --- Helper Functions ---

	getPaymentMethod() {
		const checkedInput = this.form.querySelector(
			'input[name="paymentMethod"]:checked',
		);
		return checkedInput ? checkedInput.value : null;
	}

	disableButton() {
		if (!this.submitButton) return;
		this.submitButton.classList.add('btn--is-waiting');
		this.submitButton.setAttribute('disabled', 'disabled');
	}

	enableButton() {
		if (!this.submitButton) return;
		this.submitButton.classList.remove('btn--is-waiting');
		this.submitButton.removeAttribute('disabled');
	}
}
